import moment from 'moment-timezone';

window.moment = moment;

export default function EventCard({ getSectionImage, event, types }) {
    const { name, description, start, duration_mins, event_type_id, external_link, slug } = event;

    const eventType = types.find(e => e.id === event_type_id);

    return (
        <div class="bg-white border hover:border-0 hover:shadow-2xl border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
            <a href={`/events/${slug}`} aria-label="Item Image Link">
                <div className="w-full h-[20rem] sm:h-[12rem] bg-cover" style={{
                    backgroundImage: `url('${getSectionImage(event)}')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                }}></div>
            </a>
            <div class="h-[calc(100%_-_20rem)] sm:h-[calc(100%_-_12rem)] px-5 py-5 flex flex-col justify-between">
                <div className="flex flex-col">
                    { name && <h2 class="leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">{ name }</h2> }

                    { start && <p class="mt-3 mb-2 font-normal text-base text-gray-500 dark:text-gray-400">Date: { moment(start).tz("Europe/London").format('DD/MM/YYYY') }</p> }
                    { duration_mins && <p class="mb-4 font-normal text-base text-gray-500 dark:text-gray-400">Duration: { moment(start).tz("Europe/London").format('HH:mm A') } - { moment(start).tz("Europe/London").add(duration_mins, 'minutes').format('HH:mm A') }</p> }

                    { description && <p class="mt-3 mb-4 font-normal text-base text-gray-500 dark:text-gray-400">{ description?.substr(0, 200) }</p> }
                </div>

                <a href={`/events/${slug}`} aria-label={`Read more about ${name}`} role="link" class="w-fit text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Read More
                    <svg aria-hidden="true" class="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </a>
            </div>
        </div>
    )
}
